import { cn } from '@cobliteam/colib-ui/cn';
import Spinner from '@cobliteam/colib-ui/Spinner';
import Typography from '@cobliteam/colib-ui/Typography';
import { useLoginBanner } from '@cobliteam/hooks/src/useEntity/usePrismic';
import { useTranslation } from '@cobliteam/i18n';
import { PrismicButton, PrismicImage, PrismicRichText } from '@cobliteam/prismic';
import type { ReactNode } from 'react';

const Panel = ({ children, className }: { children: ReactNode; className?: string }) => (
  <div className={cn('relative flex size-full items-center justify-center overflow-hidden bg-linear-160 from-royal-900 to-70% to-royal-950 p-12', className)}>
    <img src='/static/images/login/bg-rings.svg' alt='' aria-hidden className='pointer-events-none absolute inset-0 size-full object-cover' />
    {children}
  </div>
);

const LoginMKT = () => {
  const { t } = useTranslation();
  const { data, isPending, isError } = useLoginBanner();
  if (!data && isPending) {
    return (
      <Panel>
        <Spinner className='relative size-6 text-white' aria-label={t('common:messages.loading')} />
      </Panel>
    );
  }
  if (!data || isError) {
    return (
      <Panel>
        <Typography variant='body' className='relative gap-1 break-words text-white'>
          Ocorreu um erro ao carregar o conteúdo
        </Typography>
      </Panel>
    );
  }
  const content = data.data;
  return (
    <Panel>
      <div className='relative flex w-full max-w-[440px] flex-col gap-8'>
        {/* A arte do Prismic é PNG transparente desenhado sobre royal-700, com uma faixa vazia embaixo; o card mantém a cor e corta a faixa. */}
        <div className='aspect-419/318 overflow-hidden rounded-2xl bg-royal-700'>
          <PrismicImage
            field={content.image}
            className='size-full object-cover object-top'
            widths={[392, 440, 880]}
            imgixParams={{
              q: 75,
            }}
          />
        </div>
        <div className='flex flex-col gap-3'>
          <PrismicRichText field={content.title} className='text-white' />
          <PrismicRichText field={content.description} className='text-white/80' />
        </div>
        <div className='flex gap-3'>
          {/* No banner azul o CTA é sempre outline, seja qual for a variante cadastrada no Prismic. */}
          {content.buttons.map((button, idx) => (
            <PrismicButton button={button} key={idx} variant='outline' analytics_track={content.analytics_track} />
          ))}
        </div>
      </div>
    </Panel>
  );
};

export default LoginMKT;
